import ChartComponent from '@components/dashboard/ChartComponent'

export function formatReportNumber(value) {
  return new Intl.NumberFormat('pt-BR').format(value || 0)
}

export function formatReportCurrency(value) {
  return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value || 0)
}

export function formatReportDate(value) {
  if (!value) return '—'
  const raw = String(value).slice(0, 10)
  const [year, month, day] = raw.split('-')
  return year && month && day ? `${day}/${month}/${year}` : raw
}

export function ReportStat({ index, label, value, detail, icon = 'fa-chart-simple', tone = '' }) {
  return (
    <article className={`report-stat ${tone}`}>
      {index ? <span className="report-stat-index" aria-hidden="true">{index}</span> : null}
      <div>
        <span>{label}</span>
        <strong>{value}</strong>
        {detail ? <small>{detail}</small> : null}
      </div>
      <i className={`fas ${icon}`} aria-hidden="true" />
    </article>
  )
}

export function ReportChartCard({ eyebrow, title, type, data, options, className = '' }) {
  return (
    <section className={`report-card report-chart ${className}`}>
      <div className="report-card-title">
        <div>
          {eyebrow ? <span>{eyebrow}</span> : null}
          <h3>{title}</h3>
        </div>
      </div>
      <div className="report-chart-canvas">
        <ChartComponent type={type} data={data} options={options} />
      </div>
    </section>
  )
}

export function ReportEmptyState({ icon = 'fa-folder-open', title, description }) {
  return (
    <div className="report-empty">
      <i className={`fas ${icon}`} aria-hidden="true" />
      <h3>{title}</h3>
      {description ? <p>{description}</p> : null}
    </div>
  )
}
